import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import paddingExample4 from './assets/images/padding-example4.png';
import paddingExample5 from './assets/images/padding-example5.png';


const CSSLesson36 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   div {
    width: 300px;
    padding: 25px;
   }
  `
  );
  const code1 = (
  'text',
  `
   div {
    width: 300px;
    padding: 25px;
    box-sizing: border-box;
   }
  `
  );

  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>


          <div className="alert alert-secondary" role="alert">
          <h3><strong>Padding and Element Width</strong></h3>
 <p>The CSS <b class="text-danger">width property</b> specifies the width of the element's content area. The content area is the portion inside the padding, border, and margin of an element (the box model).</p>
 <p>This means that if an element has a specified width, the padding added to that element will be added to the total width of the element. This is often an undesirable result.</p>
 <CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    /><p>Here, the <b class="text-danger">&lt;div&gt;</b> element is given a width of 300px. However, the actual width of the <b class="text-danger">&lt;div&gt;</b> element will be 350px (300px + 25px of left padding + 25px of right padding):</p>
<p>To keep the width at 300px, no matter the amount of padding, you can use the <b class="text-danger">box-sizing property</b>. This causes the element to maintain its actual width; if you increase the padding, the available content space will decrease.</p>
<CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    /><p>The <span class="text-danger">border-box</span> property makes it possible for an element’s specified width and height not to be affected by padding or borders. This has proven so useful in responsive design.</p>
    </div>
    
          
                          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson36;
